import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcTreatment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.708 17.475H2.292V2.525h15.425v14.95h-.009Zm-14.166-1.25h12.925V3.775H3.542v12.45Z"
    />
    <path
      fill="currentColor"
      d="M6.85 9.192a2.141 2.141 0 1 1-.001-4.282 2.141 2.141 0 0 1 0 4.282Zm0-3.025a.893.893 0 0 0 0 1.783.893.893 0 0 0 0-1.783ZM15.45 6.434h-5.442v1.25h5.442v-1.25ZM6.85 14.408a2.141 2.141 0 1 1-.001-4.282 2.141 2.141 0 0 1 0 4.282Zm0-3.025a.893.893 0 0 0 0 1.784.893.893 0 0 0 0-1.784ZM15.45 11.65h-5.442v1.25h5.442v-1.25Z"
    />
  </svg>
);
export default SvgIcTreatment;
